// src/utils/axios.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://gst-transport-backend.onrender.com';

console.log('🔧 Configuration Axios:');
console.log('🌐 API URL:', API_URL);
console.log('🏷️ Environnement:', process.env.NODE_ENV);

const instance = axios.create({
  baseURL: API_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 🔥 INTERCEPTEUR POUR NOTIFIER LE DASHBOARD DES MODIFICATIONS
instance.interceptors.response.use(
  (response) => {
    // Vérifier si c'est une modification (POST, PUT, PATCH, DELETE)
    const method = response.config.method?.toLowerCase();
    const isMutation = ['post', 'put', 'patch', 'delete'].includes(method);
    
    if (isMutation && response.config.url) {
      // Déterminer la ressource modifiée
      let resource = null;
      const url = response.config.url;
      
      if (url.includes('/api/clients')) resource = 'clients';
      else if (url.includes('/api/ventes')) resource = 'ventes';
      else if (url.includes('/api/achats')) resource = 'achats';
      else if (url.includes('/api/chauffeurs')) resource = 'chauffeurs';
      else if (url.includes('/api/vehicules')) resource = 'véhicules';
      else if (url.includes('/api/fournisseurs')) resource = 'fournisseurs';
      
      if (resource) {
        // Dispatcher un événement personnalisé
        const event = new CustomEvent('dashboard-refresh', {
          detail: {
            resource,
            action: method,
            timestamp: new Date(),
            success: response.data?.success
          }
        });
        window.dispatchEvent(event);
        
        console.log(`🔄 Dashboard: ${method} sur ${resource} - Rafraîchissement déclenché`);
      }
    }
    
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour debug
instance.interceptors.request.use(
  (config) => {
    console.log('📤 REQUEST:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      fullUrl: config.baseURL + config.url,
    });
    
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;